var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bet-chip-selector",
      class: { "bet-chip-selector--fancy": _vm.fancy },
      attrs: { "aria-label": _vm.$t("Bet chips") },
    },
    [
      _vm._l(_vm.chips, function (chip, index) {
        return _c(
          "button",
          {
            key: chip,
            staticClass: "bet-chip-selector__option",
            class: {
              "bet-chip-selector__option--active": _vm.isChipActive(chip),
            },
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.$emit("select-chip", chip)
              },
            },
          },
          [
            _c(
              "Chip",
              {
                staticClass: "bet-chip-selector__chip",
                attrs: { "chip-value": chip, "display-only": "" },
              },
              [_c("ChipDisplay", { attrs: { chip: _vm.chipColors[index] } })],
              1
            ),
          ],
          1
        )
      }),
      _vm.custom
        ? _c("CustomChip", {
            staticClass: "bet-chip-selector__option bet-chip-selector__custom",
            attrs: {
              "display-only": "",
              "active-chip": _vm.activeChip,
              "arena-id": _vm.arenaId,
            },
            on: {
              "select-chip": function ($event) {
                return _vm.$emit("select-chip", $event)
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }